export default function validate({ overrideStartDate, overrideEndDate }) {
  const errors = {}
  if (overrideEndDate && overrideEndDate < overrideStartDate) {
    errors.overrideEndDate = 'End Date should be greater than start date'
  }

  return errors
}
